import { component } from 'picoapp';
import Drawer from '../../js/utils/drawer';

export default component(async (node) => {
  /**
   * Data + elements
   */
  const drawerElement = node.querySelector('.js-drawer');
  const drawerCloseBtn = node.querySelector('.js-closeBtn');
  const drawerBtn = node.querySelector('.js-drawerBtn');

  /**
   * Functions
   */
  const initDrawer = () => {
    const drawer = Drawer(drawerElement);
    drawerBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      drawer.open();
    });
    drawerCloseBtn.addEventListener('click', () => drawer.close());
  };

  const init = () => {
    initDrawer();
  };

  /**
   * Init
   */
  init();
});
